import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export function Button(props) {
    return (
        <div className={props.divclass}>
            <button type={props.btnType} id={props.btnId} className={props.btnClass} onClick={props.btnClick}>
                <span data-hover={props.spanHover}>{props.faIcon ? <FontAwesomeIcon icon={props.faIcon} /> : '' }  {props.btnName}</span>
            </button>
        </div>
    )
}

